import React from 'react';
import { Button, Checkbox, FormField, Message } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import { ChevronRight } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Flex, Link, Text } from 'rebass/styled-components';

import { FormImage } from '../../../../components/molecules/formImage';
import { useProfile } from './useProfile';

export const Profile = ({ sharedList }) => {
  const { user, initialValues, formSchema, isLoading, onSubmit } = useProfile({ sharedList });

  return (
    <>
      <Text fontSize="22px" fontWeight="semibold" color="text.dark">
        Welcome!
      </Text>
      <Text mt="16px" mb="32px">
        Let’s complete your profile.
      </Text>
      <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit}>
        {({ values, handleChange, errors, status }) => (
          <Form>
            <Flex flexDirection="column" sx={{ gap: '8px' }}>
              <Flex mb="8px" alignItems="center" sx={{ gap: '16px' }}>
                <Field
                  name="avatarUrl"
                  component={FormImage}
                  imagePlaceholder={`${values.firstName} ${values.lastName}`}
                />
              </Flex>
              <Field type="text" name="firstName" label="First name" component={FormField} />
              <Field type="text" name="lastName" label="Last name" component={FormField} />
              {!user.email && (
                <>
                  <Field
                    type="email"
                    name="email"
                    label="Email"
                    component={FormField}
                    disabled={!!initialValues.email}
                  />
                  <Field
                    autoComplete="new-password"
                    type="password"
                    name="password"
                    label="Password"
                    component={FormField}
                  />
                </>
              )}
              <Box>
                <Checkbox
                  checked={values.termsAccepted}
                  onChange={handleChange}
                  name="termsAccepted"
                  label={
                    <Text as="span">
                      I have read and I do accept the{' '}
                      <Link
                        href="https://www.getro.com/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="text.main"
                      >
                        terms of service
                      </Link>{' '}
                      and{' '}
                      <Link
                        href="https://www.getro.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="text.main"
                      >
                        privacy policy
                      </Link>
                    </Text>
                  }
                />
                {errors?.termsAccepted && (
                  <Message mt="16px" type="error">
                    {errors.termsAccepted}
                  </Message>
                )}
                {!!status?.error && <Message mt="16px" type="error" content={status.error} />}
              </Box>
              <Button
                type="submit"
                mt="16px"
                icon={ChevronRight}
                iconPosition="right"
                loading={isLoading}
                sx={{ justifyContent: 'center' }}
              >
                Continue
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </>
  );
};

Profile.propTypes = {
  sharedList: PropTypes.object.isRequired,
};
